import i18n from '@/i18n'
import { UserRoleId } from '@/types/authorisation/role-id.enum'

const { t } = i18n.global

export function userRoleNameLocalised(userRoleId: UserRoleId): string {
  switch (userRoleId) {
    case UserRoleId.SysAdmin:
      return t('auth.role.systemAdmin')

    case UserRoleId.PartnerAdmin:
      return t('auth.role.partnerAdmin')

    case UserRoleId.PartnerTechnician:
      return t('auth.role.partnerTechnician')

    case UserRoleId.OrganisationAdmin:
      return t('auth.role.organisationAdmin')

    case UserRoleId.OrganisationUser:
      return t('auth.role.organisationUser')

    case UserRoleId.SiteFuelDataContributor:
      return t('auth.role.siteFuelDataContributor')

    case UserRoleId.SiteUser:
      return t('auth.role.siteUser')

    case UserRoleId.FuelDataContributor:
      return t('auth.role.fuelDataContributor')

    default:
      return t('words.unknown')
  }
}
